module.exports = __webpack_public_path__ + "img/reason3.444e953a.png";